import { FC, useState } from 'react';

import { values } from 'remeda';
import useSWRMutation from 'swr/mutation';

import { slotService } from 'v2/api/slotService';
import { CheckBoxAutocomplete } from 'v2/components/autocomplete/checkBoxAutocomplete/CheckBoxAutocomplete';
import { SlotMark } from 'v2/constants';
import { SlotModel } from 'v2/types/SlotModel';
import { handleHttpError } from 'v2/utils';

interface SlotTableMarksColumnProps {
  slot: SlotModel;
}

export const SlotTableMarksColumn: FC<SlotTableMarksColumnProps> = ({ slot }) => {
  const [marks, setMarks] = useState(slot.marks);

  const { trigger } = useSWRMutation(['updateSlotMarks', slot.id], slotService.updateSlotMarks, {
    onSuccess: (slot) => {
      setMarks(slot.marks);
    },
    onError: handleHttpError,
  });

  const handleChange = (values: SlotMark[]) => {
    trigger(values);
  };

  return <CheckBoxAutocomplete label="Marks" value={marks} options={values(SlotMark)} onChange={handleChange} />;
};
